import { state } from "../store";
import { setRoot, showError } from "../render";
import { fetchDayAvailability } from "../api";
import type { SlotAvailability } from "../types";

export async function renderStep2() {
  const date = state.draft.reservation_date!;
  // Phase 1.5.4 拡張：reschedule モード時は Step 表示を「2 / 2（変更）」に変える
  const isReschedule = state.reschedule !== null;
  const stepLabel = isReschedule ? "Step 2 / 2（変更）" : "Step 2 / 5";
  const titlePrefix = isReschedule ? "🔄 新しい時間を選択" : "🕒 時間を選択";
  setRoot(`
    <header class="text-center pb-3 border-b">
      <h1 class="font-bold text-lg">${titlePrefix}</h1>
      <p class="text-xs text-gray-500 mt-1">${stepLabel}</p>
    </header>
    <p class="mt-3 text-center text-sm text-gray-600">${formatDate(date)} の空き時間</p>
    <div id="slots" class="mt-3 grid grid-cols-2 gap-2">
      <div class="col-span-2 text-gray-400 text-center py-4">読み込み中...</div>
    </div>
    <div class="mt-auto pt-4 flex gap-2 items-center">
      <button id="back-btn" class="flex-1 bg-gray-300 text-gray-800 py-3 rounded">戻る</button>
      <div class="flex-[2] text-center text-xs text-gray-500">時間枠をタップで次へ進みます</div>
    </div>
  `);

  document.getElementById("back-btn")!.addEventListener("click", async () => {
    const { renderStep1 } = await import("./step1Date");
    renderStep1();
  });

  let slots: SlotAvailability[] = [];
  try {
    slots = await fetchDayAvailability(date);
  } catch (e: any) {
    showError(e?.message ?? "通信エラー");
    return;
  }

  const grid = document.getElementById("slots")!;
  grid.innerHTML = "";
  for (const s of slots) {
    const btn = document.createElement("button");
    btn.textContent = s.time;
    if (s.available) {
      btn.className = "bg-green-500 text-white rounded py-3 font-bold";
      btn.addEventListener("click", () => selectSlot(s.time, btn));
    } else {
      btn.className = "bg-gray-300 text-gray-500 rounded py-3 cursor-not-allowed";
      btn.disabled = true;
    }
    grid.appendChild(btn);
  }
}

async function selectSlot(time: string, btn: HTMLElement) {
  state.draft.reservation_time = time;
  document.querySelectorAll("#slots button").forEach((b) => {
    (b as HTMLElement).style.outline = "";
  });
  btn.style.outline = "2px solid #047857";

  // 視覚フィードバック後に自動遷移
  await new Promise((r) => setTimeout(r, 150));

  // Phase 1.5.4 拡張：reschedule モード時は step3-4（顧客名・業種・相談内容）を
  // 旧予約から引き継いでいるので skip して step5（確認）へ直行
  if (state.reschedule !== null) {
    const { renderStep5 } = await import("./step5Confirm");
    renderStep5();
    return;
  }

  const { renderStep3 } = await import("./step3Customer");
  renderStep3();
}

function formatDate(date: string): string {
  const [, m, d] = date.split("-").map(Number);
  return `${m}/${d}`;
}
